module.exports = __webpack_public_path__ + "373148bb0c94b5e965b5d1a3a0610dd5.svg";